import { lang } from '@umu/ukit-lang';
/*
 * @author: wayou
 * @date: 2018-12-19 14:56:59
 * @description: 关键词处理中的占位
 */

import React from 'react';
import { components } from 'common';
const { PreImg } = components;
import './keyWrodsEmpty.scss';

import aiNoContentImg from './images/ai_loading.png';

interface IKeyWordsEmptyProps {
    title?: string;
    subTitle?: string;
}

export default function keyWrodsEmpty(props: IKeyWordsEmptyProps) {
    const title = props.title || lang('尚未检测到文字');
    const subTitle = props.subTitle || lang('我正在努力识别和分析中~');
    return (
        <div className="ai-summary-no-content ai-summary-empty">
            <PreImg>
                <img src={aiNoContentImg} alt="" />
            </PreImg>
            <p className="ai-summary-no-content-text">{title}</p>
            <p className="ai-summary-no-content-text">{subTitle}</p>
        </div>
    );
}
